// extracted by mini-css-extract-plugin
export default {"wrapper":"xr-z","viewport":"yr-z","container":"zr-z","slide":"Ar-z"};